module.exports = __webpack_public_path__ + "static/media/AddLogo.9e0519dd.svg";